// AB#1749 — Calendar grid (C3 of Calendar v1 Epic AB#1746).
// Read-only TanStack Query hook backing the owner day-view at /calendar.
// No mutations in this PR — booking / status change are sibling PRs
// (C5/C6 + C4 respectively).

import { useQuery } from '@tanstack/react-query';
import { apiService } from '../services/api';
import { queryKeys } from '../lib/queryKeys';
import type { CalendarGridResponse } from '../types/api-responses';

export interface UseCalendarGridParams {
    branchId: number | null;
    /** "yyyy-MM-dd" — local date the owner is viewing. */
    date: string;
}

/**
 * Fetch the calendar grid payload for a single (branch, date). 30-second
 * staleTime — the grid changes when an appointment is booked / modified;
 * the upcoming C7 SignalR push will invalidate this key on every
 * relevant `business:{id}` event.
 *
 * Disabled when `branchId == null` — happens momentarily on first load
 * for multi-branch businesses before the branch picker resolves.
 */
export const useCalendarGridQuery = (params: UseCalendarGridParams) =>
    useQuery<CalendarGridResponse>({
        queryKey: queryKeys.calendar.grid({
            branchId: params.branchId ?? 0,
            date: params.date,
        }),
        queryFn: () => apiService.getCalendarGrid({
            branchId: params.branchId as number,
            date: params.date,
        }),
        enabled: params.branchId != null && params.branchId > 0,
        staleTime: 30_000,
    });
